import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthenticationMethodEnum, UserTypeEnum } from "@cai-services";
import { RegisterService } from "../_services/register.service";
import { SessionService } from "../_services/session.service";

@Injectable()
export class QuoteDetailGuard {
  constructor (
    private readonly router: Router,
    private readonly sessionService: SessionService,
    private readonly registerService: RegisterService
  ) {}

  async canActivate (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    let token = route.firstChild.queryParams.token;

    if (!token) {
      token = route.firstChild.paramMap.get("token");
      if (token) {
        //put the token on queryParams
        this.router.navigate([state.url], {
          "queryParams": { token },
        });
        return false;
      }
    }
    let loggedInUser = this.sessionService.getCurrentUser();
    if (
      loggedInUser &&
      loggedInUser?.authenticationMethod !== AuthenticationMethodEnum.TOKEN &&
      token &&
      loggedInUser?.type !== UserTypeEnum.AIRLINE
    ) {
      this.router.navigate(["/error/incorrect-login"], {
        "queryParams": { "return": state.url, token },
      });
      return false;
    }
    loggedInUser =
      loggedInUser ?? (await this.getGuestUserWithTemporaryCredentials(token));

    if (!loggedInUser) {
      this.router.navigate(["/auth/login"], {
        "queryParams": { "return": state.url },
      });
      return false;
    }

    this.sessionService.setCurrentUser(loggedInUser);
    await this.sessionService.initSelectedOffice(token);

    return true;
  }

  async getGuestUserWithTemporaryCredentials (authToken: string) {
    return await this.registerService.getUser(authToken);
  }
}
